import { Container, List, Paper, Typography } from '@material-ui/core';
import React, { useState } from "react";
import { TutorialListItem } from "./tutorial-list-item";

const ManagerTutorial = () => {

    const urls = {
        'item0': 'LFTMcFKZlWg',
        'item1': 'otTczcCy7bQ',
        'item2': '3TMMbm9O5KU',
        'item3': 'uLVD3etIu-w',
        'item4': 'AL1aG6zPX1g',
        'item5': '4aR9Ytx-IH8',
        'item6': 'FwvhFjyR7mU',
        'item7': 'Dt_RaSYYMyc',
        'item8': 'P7VG-p9Q5j0',
        'item9': '_ZXOZfTh_Kw',
       'item10': 'jfPvRQJDBwA',
    }

    const [state, setState] = useState({
        'item0': false,
        'item1': false,
        'item2': false,
        'item3': false,
        'item4': false,
        'item5': false,
        'item6': false,
        'item7': false,
        'item8': false,
        'item9': false,
        'item10': false,
    })

    const handleClick = (item) => {
        setState((state) => ({ ...state, [item]: !state[item] }));
    }

    return (
        <Container>
            <Paper style={{ padding: '25px' }}>
                <Typography variant={'h6'}> Tutoriais do gestor</Typography>
                <Typography variant={'body1'}>Nossa equipe preparou uma série de tutoriais para ajudar na compreensão do sistema e sanar as dúvidas mais comuns quanto à utilização do Juristta Office.</Typography>
                <List>
                    <TutorialListItem open={state.item0} label={'Como fazer login'} url={urls.item0} onClick={() => handleClick('item0')} />
                    <TutorialListItem open={state.item1} onClick={() => handleClick('item1')} label={'1 - Uma visão geral da plataforma'} url={urls.item1} />
                    <TutorialListItem open={state.item2} onClick={() => handleClick('item2')} label={'2 - Configuração de Período Letivo e Turmas'} url={urls.item2} />
                    <TutorialListItem open={state.item3} onClick={() => handleClick('item3')} label={'3 - Criando a classificação de tipos de processo'} url={urls.item3} />
                    <TutorialListItem open={state.item4} onClick={() => handleClick('item4')} label={'4 - Como fazer a triagem dos pedidos de atendimento)'} url={urls.item4} />
                    <TutorialListItem open={state.item5} onClick={() => handleClick('item5')} label={'5 - Como atribuir um atendimento a um gestor e / ou aluno'} url={urls.item5} />
                    <TutorialListItem open={state.item6} onClick={() => handleClick('item6')} label={'6 - Incluindo notas e anexos no atendimento'} url={urls.item6} />
                    <TutorialListItem open={state.item7} onClick={() => handleClick('item7')} label={'7 - Inserindo partes em um processo'} url={urls.item7} />
                    <TutorialListItem open={state.item8} onClick={() => handleClick('item8')} label={'8 - Inserindo o número do processo de um atendimento'} url={urls.item8} />
                    <TutorialListItem open={state.item10} onClick={() => handleClick('item9')} label={'9 - Corrigindo uma atividade entregue pelos alunos'} url={urls.item10} />
                    <TutorialListItem open={state.item9} onClick={() => handleClick('item10')} label={'10 - Configurando o envio de notificações'} url={urls.item9} />
                </List>
            </Paper>
        </Container >
    )
}

export default ManagerTutorial;